<template lang="html">

  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Total Minted" :help="help1" :secondline="$options.filters.toCurrency(mintedUSD, 0, 'USD')" color="#07D3DA">{{ minted | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Staked" :help="help2" :secondline="$options.filters.toCurrency(stakedUSD, 0, 'USD')" color="#C6362F">{{ staked | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Wallets/Liquid" :help="help3" :secondline="$options.filters.toCurrency(walletsUSD, 0, 'USD')" color="#BDD358">{{ wallets | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <!-- <v-col cols="12" md="6" lg="3">
        <NumberCard title="Uniswap" :help="help3" :secondline="$options.filters.toCurrency(uniswapUSD, 0, 'USD')" color="#BDD358">{{ uniswap | toInt(0, "WISE")}}</NumberCard>
      </v-col> -->
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Insurance Stakings"  :secondline="$options.filters.toCurrency(insuranceUSD, 0, 'USD')" :help="help4" color="#E28413">{{ insurance | toInt(0, "WISE")}}</NumberCard>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12" md="12" lg="12">
          <StakingPercentage />
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
  import NumberCard from "@/components/widgets/NumberCard.vue";
  import StakingPercentage from "@/components/StakingPercentage.vue";

  import {
    mapState
  } from 'vuex';

  export default {
    name: "Staking",
    components: {
      NumberCard,
      StakingPercentage
    },
    data() {
      return {
        minted: 0,
        staked: 0,
        wallets: 0,
        uniswap: 0,
        insurance: 0,
        currentPriceUSD: 0,
        help1: "All included: Staked + Liquid + Uniswap",
        help2: "",
        help3: "",
        help4: "Insurance stakes are part of \"Staked\"",
      }
    },
    computed: {
      mintedUSD() {
        return this.minted * this.currentPriceUSD;
      },
      stakedUSD() {
        return this.staked * this.currentPriceUSD;
      },
      walletsUSD() {
        return this.wallets * this.currentPriceUSD;
      },
      uniswapUSD() {
        return this.uniswap * this.currentPriceUSD;
      },
      insuranceUSD() {
        return this.insurance * this.currentPriceUSD;
      },
      ...mapState({
        currentETHPrice: state => state.currentETHPrice,
        currentUniswapStats: state => state.currentUniswapStats,
        totalStaked: state => state.totalStaked,
        totalSupply: state => state.totalSupply,
        uniswapBalance: state => state.uniswapBalance,
        totalStakedInsurance: state => state.totalStakedInsurance,
      }),
    },
    mounted() {
      this.updatePrice();
      this.updateAllCards();
    },
    methods: {
      updatePrice() {
        this.currentPriceUSD = this.$store.state.currentUniswapStats.priceETH * this.$store.state.currentETHPrice
      },
      updateAllCards() {
        this.updateCard1();
        this.updateCard2();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.totalSupply > -1 &&
          this.$store.state.totalStaked > -1
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.totalStaked > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.totalSupply > -1 &&
          this.$store.state.uniswapBalance > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.totalStakedInsurance > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          this.minted = this.$store.state.totalSupply + this.$store.state.totalStaked;
        }
      },
      updateCard2() {
        if (this.isDataFetchedCard2()) {
          this.staked = this.$store.state.totalStaked;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          this.wallets = this.$store.state.totalSupply - this.$store.state.uniswapBalance;
        }
      },
      // updateCard3() {
      //   if (this.isDataFetchedCard3()) {
      //     this.uniswap = this.$store.state.uniswapBalance;
      //   }
      // },
      updateCard4() {
        if (this.isDataFetchedCard4()) {
          this.insurance = this.$store.state.totalStakedInsurance;
        }
      },
    },
    watch: {
      currentETHPrice() {
        this.updatePrice();
      },
      currentUniswapStats() {
        this.updatePrice();
      },
      totalStaked() {
        this.updateCard1();
        this.updateCard2();
      },
      totalSupply() {
        this.updateCard1();
        this.updateCard3();
      },
      uniswapBalance() {
        this.updateCard3();
      },
      totalStakedInsurance() {
        this.updateCard4();
      },
    }
  }
</script>

<style lang="css" scoped>
</style>
